import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";

import Button from "../../components/button/Button";
import NillDisplaySchedule from "../../components/nillDisplaySchedule/NillDisplaySchedule";
import { ICONS } from "../../constants/icons.constants";
import playlistStore from "../../zustand/playlist.store";
import Table from "../../components/table/Table";
import { columns } from "../../config/myPlaylist.config";

import styles from "./myPlayListPage.module.scss";
import userStore from "../../zustand/user.store";
import imageStore from "../../zustand/image.store";
import { downloadPlaylistImage } from "../../helpers/generel.helpers";

const MyPlayListPage = () => {
  const navigate = useNavigate();

  const { playlists } = playlistStore((state) => ({
    playlists: state.playlists,
  }));

  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));
  const { addImage } = imageStore((state) => ({
    addImage: state.addImage,
  }));

  const [isVisible, setIsVisible] = useState(false);

  const handleNewPlayListClick = () => {
    navigate("/my-playlist/new");
  };

  const handlePlayListClick = (row) => {
    if (!userOffline) navigate(`/my-playlist/view/${row.id}`);
  };

  const downloadPlaylistImages = useCallback(async () => {
    for (let i = 0; i < playlists.length; i++) {
      const currentPlayList = playlists[i];
      const image = currentPlayList?.image;

      const isSucess = await downloadPlaylistImage(image);
      if (isSucess) {
        addImage(image);
      }
    }
  }, [addImage, playlists]);

  useEffect(() => {
    downloadPlaylistImages();
  }, [downloadPlaylistImages]);

  return (
    <>
      <div className={styles.header}>
        <p>My Playlist</p>
        {!isEmpty(playlists) && (
          <Button
            hasIcon
            iconType={ICONS.PLUS}
            className={styles.btn}
            onClick={handleNewPlayListClick}
            disabled={userOffline}
          >
            New PlayList
          </Button>
        )}
      </div>
      {!isEmpty(playlists) ? (
        <div className={styles.myPlayListPage}>
          <div className={styles.songsContainer}>
            <Table
              rows={playlists}
              columns={columns}
              handleRowClick={handlePlayListClick}
            />
          </div>
        </div>
      ) : (
        <div
          className={styles.myPlayListPage}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <NillDisplaySchedule
            head="You do not have any schedules you can create one for you here"
            btnPlaceholder="Create Playlist"
            iconType={ICONS.MY_PLAYLIST}
            onBtnClick={handleNewPlayListClick}
          />
        </div>
      )}

      {isVisible && (
        <div
          className={styles.background}
          onClick={() => {
            setIsVisible(false);
          }}
        />
      )}
    </>
  );
};

export default MyPlayListPage;
